import { render } from "./ProjectDisplay.vue?vue&type=template&id=0db13820&scoped=true&ts=true"
import script from "./ProjectDisplay.vue?vue&type=script&lang=ts"
export * from "./ProjectDisplay.vue?vue&type=script&lang=ts"

import "./ProjectDisplay.vue?vue&type=style&index=0&id=0db13820&lang=scss&scoped=true"

import exportComponent from "/builds/Chirbou/isolation/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0db13820"]])

export default __exports__